import { render, staticRenderFns } from "./multiselectField.vue?vue&type=template&id=3f2ad142&lang=pug&"
import script from "./multiselectField.vue?vue&type=script&setup=true&lang=js&"
export * from "./multiselectField.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports